/** Main miniapp package ID */
export const MINIAPP_PACKAGE_ID = 'com.picsart.ai-wardrobe';

/** Root Drive folder for all generated looks (used when creating the folder) */
export const ROOT_FOLDER_NAME = 'AI Stylist';
export const OLD_ROOT_FOLDER_NAME = 'My Looks';

/**
 * All accepted root-folder names, current name first. Lookups iterate this list
 * in order and reuse the first match: prefer the new "AI Stylist" folder, then
 * fall back to a legacy "My Looks" so existing users keep their saved looks
 * rather than orphaning them in a renamed folder.
 */
export const ROOT_FOLDER_NAMES = [ROOT_FOLDER_NAME, OLD_ROOT_FOLDER_NAME] as const;

/** Related miniapp package IDs */
export const MINIAPP_PACKAGE_IDS = {
  EXPORT_AND_SHARE: 'com.picsart.edit.export-and-share',
  DRIVE_CHOOSER: 'com.picsart.social.drive-chooser',
} as const;

export const APP_API_URL = import.meta.env.VITE_API_URL || process.env.VITE_API_URL || 'https://api.picsart.com';
export const PICSART_APP_URL = import.meta.env.VITE_PICSART_APP_URL || process.env.VITE_PICSART_APP_URL || 'https://picsart.com';
export const APP_UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL || process.env.VITE_UPLOAD_URL || 'https://upload.picsart.com';
export const APP_DRIVE_URL = import.meta.env.VITE_DRIVE_API_URL || APP_API_URL.replace(/^https:\/\/api(-stage)?\./, 'https://api$1.us-east1.');
export const APP_WEBHOOK_URL = import.meta.env.VITE_WEBHOOK_API_URL || APP_API_URL;

/** Magic-flow webhook IDs. WARDROBE_GENERATE is env-specific (falls back to prod). */
export const WEBHOOK_IDS = {
  WARDROBE_GENERATE: (import.meta.env.VITE_WARDROBE_GENERATE_WEBHOOK_ID as string) || '69e6028e1a408b13e42fcd6f',
  WARDROBE_THUMBNAIL: '69e607a1044fa429484e5cde',
  WARDROBE_SUGGEST: '69e609f31a408b13e42fddff',
} as const;

/** Legal pages shown in GenerateFooter */
export const TERMS_URL = `${PICSART_APP_URL}/terms-and-conditions`;
export const PRIVACY_POLICY_URL = `${PICSART_APP_URL}/privacy-policy`;

/** Tool ID for monetization (getToolPrice + OpenOfferScreen) */
export const MONETIZATION_TOOL_ID = 'picsart-ai-wardrobe';
